<template>
    <div class="nav-menu-router">
        <div class="horizontal nav-menu-router-parent" style="padding: 10px 15px;">
            <router-link :id="'rl-' + routerTo" style="width: 100%" :to="{name: routerTo, params: params}">
                <div class="horizontal router-container">
                    <slot name="icon" style="height: 30px;"></slot>
                    <span style="margin-left: 10px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ $t(title) }}</span>
                </div>
            </router-link>
            <div style="width: 50px;" v-if="hasDropdown && !alwaysDropdown" class="dropdown-icon-container" @click="dropdownVisible = !dropdownVisible">
                <img src="@/assets/img/_old/arrow_down.png"/>
            </div>
        </div>
        <slot v-if="dropdownVisible || alwaysDropdown" class="dropdown-slot" name="dropdown"></slot>
    </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        routerTo: {
            type: String,
            default: 'main'
        },
        hasDropdown: {
            type: Boolean,
            default: false,
            required: false
        },
        params: {
            type: Object,
            default() {
                return {}
            }
        },
        alwaysDropdown: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    mounted() {
        // let con = this

        // this.$nextTick(_ => {
        //     var observer = new MutationObserver(function (mutations) {
        //         mutations.forEach(function (mutation) {
        //             console.log({mutation})
        //             if (mutation.target.classList.contains('router-link-active')) {
        //                 con.dropdownVisible = true
        //             } else {
        //             }
        //         });
        //     });

        //     var node = document.querySelector('#rl-' + con.routerTo)

        //     observer.observe(document.querySelector('#rl-' + con.routerTo), {
        //         attributes: true,
        //         attributeFilter: ['class']
        //     });

        //     con.$nextTick(__ => {
        //         node.classList.add('tst')
        //         node.classList.remove('tst')
        //     })

        //     con.$router.beforeEach((to, from, next) => {
        //         next()
        //     })
        // })
    },
    data() {
        return {
            dropdownVisible: false
        }
    }
}
</script>

<style scoped>
a > div > span {
    color: white;
    text-decoration: none;
}

a > div > span:hover {
    text-decoration: none;
}

a:hover {
    color: white;
    text-decoration: none;
}

.nav-menu-router .dropdown-slot{
    display: block;
    outline: 5px pink;

}
</style>


// WEBPACK FOOTER //
// src/components/Main/Menu/NavigationMenuRouter.vue